<template>
  <div id="TableInfoAbs">
    <div class="content-table">
      <b-row>
        <b-col cols="12" class="m-auto">
          <b-table
              show-empty
              empty-text="No hay empleados"
              :busy="processing"
              hover
              :fields="fields"
              :items="items" >
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Cargando...</strong>
              </div>
            </template>
          </b-table>
        </b-col>
        <b-col
            cols="10"
            class="m-auto"
            v-if="dataOfTable.data && !processing">
          <div class="overflow-auto my-4">
            <pagination
                :data="dataOfTable"
                :limit="10"
                @pagination-change-page="changePage" />
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataOfTable: []
    ,processing: Boolean
  }
  ,components: {
    Pagination: () => import ('laravel-vue-pagination')
  }
  ,computed: {
    fields () {
      return [
        {
          key: 'name'
          ,label: 'Nombre'
          ,sortable: true
        }
        ,{
          key: 'days'
          ,label: 'Días'
          ,sortable: true
        }
        ,{
          key: 'origin'
          ,label: 'Origen'
          ,sortable: true
        }
      ]
    }
    ,items () {
      return this.dataOfTable ?  this.dataOfTable.data : []
    }
  }
  ,methods: {
    changePage (page = 1)
    {
      this.$emit('change:page', page)
    }
  }
}
</script>

<style lang="scss">
#TableInfoAbs {
  .content-table{
      table{
        width: 100%;
        tr{
          td{
            color:#000000;
            font-weight: 600;
          }
        }
      }
    .pagination {
      justify-content: center;
    }
    button.page-link{
      color: #B0BEC5 !important;
      border: 0;
    }
    .page-item.active .page-link{
      background-color: transparent !important;
      border-color: transparent !important;;
      color: #1719DA !important;
    }
  }
}
</style>